import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const LOOKING_UP = [
  { title: 'Price to Earnings Ratio (P/E Ratio)', desc: 'How much investors are paying for every ₹1 of a company\'s profit.', cat: 'VALUATION', catStyle: 'valuation', link: '/glossary/pe-ratio' },
  { title: 'Systematic Investment Plan (SIP)', desc: 'A way to invest a fixed amount every month into a mutual fund — automatically.', cat: 'PRODUCTS', catStyle: 'products', link: '/glossary/sip' },
  { title: 'XIRR', desc: 'The true annualised return of an investment with irregular cash flows — like a SIP.', cat: 'RETURNS', catStyle: 'returns', link: '/glossary' },
  { title: 'Long Term Capital Gains (LTCG)', desc: 'Tax on profit from selling an investment held for more than 12 months.', cat: 'TAX', catStyle: 'tax', link: '/glossary/long-term-capital-gains' },
  { title: 'Inflation', desc: 'The rate at which prices rise — and your money\'s purchasing power falls.', cat: 'ECONOMICS', catStyle: 'economics', link: '/glossary' },
  { title: 'Expense Ratio', desc: 'The annual fee a mutual fund charges, expressed as a % of your investment.', cat: 'PRODUCTS', catStyle: 'products', link: '/glossary' },
];

const TOOLS = [
  { title: 'SIP Calculator', desc: 'How much will my monthly SIP grow into?', link: '/tools/sip' },
  { title: 'Lumpsum Calculator', desc: 'Project growth on a one-time investment.', link: '/tools' },
  { title: 'Inflation Calculator', desc: 'What ₹100 today will be worth tomorrow.', link: '/tools' },
];

export default function Home() {
  return (
    <div className="home">

      {/* Hero */}
      <section className="hero">
        <div className="hero-inner">
          <span className="hero-pill">FREE &bull; NO SIGNUP &bull; NO ADVICE</span>
          <h1 className="hero-heading">Plain English answers to every financial question an Indian has.</h1>
          <p className="hero-sub">
            DhanAcademy is the trusted reference for first-jobbers, salaried professionals, and anyone confused by financial news. Look it up. Understand it. Move on with your day.
          </p>
          <div className="hero-buttons">
            <Link to="/glossary" className="btn-primary">Browse the glossary</Link>
            <Link to="/tools" className="btn-outline">Try a calculator</Link>
          </div>
        </div>
      </section>

      {/* Featured + Trap */}
      <section className="featured-section">
        <div className="featured-inner">
          <Link to="/glossary/pe-ratio" className="featured-card featured-term">
            <span className="featured-label">FEATURED TERM</span>
            <h2 className="featured-title">Price to Earnings Ratio (P/E Ratio)</h2>
            <p className="featured-desc">How much investors are paying for every ₹1 of a company's profit.</p>
            <span className="featured-link">Read explanation →</span>
          </Link>
          <Link to="/mistakes" className="featured-card featured-trap">
            <span className="trap-label">TRAP OF THE WEEK</span>
            <h2 className="trap-title">Guaranteed 18% returns SMS schemes</h2>
            <p className="trap-desc">No legitimate Indian investment guarantees 18%. Anything that does is either illegal, a Ponzi scheme, or hiding huge risk in the fine print.</p>
            <span className="trap-link">See more traps →</span>
          </Link>
        </div>
      </section>

      {/* People are looking up */}
      <section className="looking-section">
        <div className="looking-inner">
          <div className="looking-header">
            <h2 className="looking-title">People are looking up</h2>
            <Link to="/glossary" className="looking-viewall">View all →</Link>
          </div>
          <div className="looking-grid">
            {LOOKING_UP.map((item, i) => (
              <Link key={i} to={item.link} className="looking-card">
                <div className="looking-card-top">
                  <span className="looking-card-name">{item.title}</span>
                  <span className={`looking-pill looking-pill-${item.catStyle}`}>{item.cat}</span>
                </div>
                <p className="looking-card-desc">{item.desc}</p>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Calculators */}
      <section className="calc-section">
        <div className="calc-inner">
          <div className="calc-header">
            <div className="calc-header-left">
              <h2 className="calc-title">Quiet, focused calculators</h2>
              <p className="calc-sub">No popups. No 'premium' tier. Just the math.</p>
            </div>
            <Link to="/tools" className="calc-viewall">All tools →</Link>
          </div>
          <div className="calc-grid">
            {TOOLS.map((tool, i) => (
              <Link key={i} to={tool.link} className="calc-card">
                <h3 className="calc-card-name">{tool.title}</h3>
                <p className="calc-card-desc">{tool.desc}</p>
                <span className="calc-card-link">Open →</span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="home-footer">
        <div className="footer-inner">
          <div className="footer-top">
            <span className="footer-brand">ध DhanAcademy</span>
            <div className="footer-links">
              <Link to="/glossary" className="footer-link">Glossary</Link>
              <Link to="/topics" className="footer-link">Topics</Link>
              <Link to="/mistakes" className="footer-link">Mistakes</Link>
              <Link to="/tools/sip" className="footer-link">Tools</Link>
              <Link to="/disclaimer" className="footer-link">Disclaimer</Link>
            </div>
          </div>
          <div className="footer-bottom">
            <span>© 2026 DhanAcademy. Free and open for everyone.</span>
            <span className="footer-disclaimer">Not financial advice. Always consult a SEBI-registered advisor.</span>
          </div>
        </div>
      </footer>

    </div>
  );
}
